import { render, staticRenderFns } from "./ProjectWorkDetail.vue?vue&type=template&id=8dfea138"
import script from "./ProjectWorkDetail.vue?vue&type=script&lang=js"
export * from "./ProjectWorkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports